
export default {
  props: {
    ratio: {
      type: String,
      default: '16/9'
    }
  }
}
